<template>
  <div class="LoggedAs__bar" ref="loggedAsBar">
    <div class="inner">
      <div class="content">
        <span class="LoggedAs__name">Bonjour <strong>{{ $page.props.current_admin.name }}</strong></span>
        <span v-if="$page.props.current_user" class="LoggedAs__fullname">Vous utilisez le compte de <strong>{{ $page.props.current_user.fullname }}</strong></span>
      </div>
      <div class="LoggedAs__links">
        <a :href="route('administration')">Administration</a>
        <a :href="$page.props.admin_logout_url">Déconnexion</a>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    mounted() {
      this.updateHeight()
      window.addEventListener('resize', this.onWindowResize);
    },
    unmounted() {
      window.removeEventListener('resize', this.onWindowResize)
    },
    methods: {
      updateHeight() {
        const {loggedAsBar} = this.$refs
        const h = loggedAsBar.offsetHeight

        const header = loggedAsBar.parentNode.querySelector(':scope > .Header')

        if(header == null) return

        const headernav = header.querySelector('.Nav__container')
        const headerLine = loggedAsBar.parentNode.querySelector(':scope > .Header__line')
        const notifContainer = loggedAsBar.parentNode.querySelector(':scope > .Notif__container')
        const app = loggedAsBar.parentNode.querySelector(':scope > main')

        if (header) header.style.top = `${h}px`
        if (headernav) {
          window.innerWidth <= 768 ? headernav.style.top = `${h + header.offsetHeight}px` : headernav.style = ``
        }
        if (headerLine) headerLine.style.top = `${h + header.offsetHeight}px`
        if (notifContainer) notifContainer.style.top = `${h + header.offsetHeight}px`
        if (app) app.style.paddingTop = `${h + header.offsetHeight}px`
      },
      onWindowResize: _.debounce(function () {
        this.updateHeight()
      }, 100)
    }
  }
</script>

<style lang="scss">
  @import "~@sass/components/_AdminBar.scss";
</style>
